"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearState = exports.setState = exports.getState = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _Dom = require("common/Dom");

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require("common/Constants");

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require("common/Helpers");

var _state = require("state");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = function getState(key) {
  if (key instanceof Element) {
    var containerId = _Dom2.default.getContainer(key).dataset.containerId;

    return getState(containerId);
  }

  var cart = _state.state.cart,
      states = (0, _objectWithoutProperties3.default)(_state.state, ["cart"]);

  var ids = (0, _entries2.default)(states).reduce(function (allState, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        name = _ref2[0],
        values = _ref2[1];

    return (0, _assign2.default)({}, allState, values);
  }, {});

  if (_state.state[key]) {
    return _state.state[key];
  } else if (ids[key]) {
    return ids[key];
  }

  return;
};

exports.getState = getState;
var setState = function setState(data) {
  var id = data.id,
      change = data.change,
      container = data.container,
      stateChange = (0, _objectWithoutProperties3.default)(data, ["id", "change", "container"]);

  var newState = void 0;

  if (id && container) {
    var oldState = _state.state[container][id];
    newState = (0, _assign2.default)({ id: id }, oldState, stateChange);
    _state.state[container][id] = newState;
  } else if (container) {
    var _oldState = _state.state[container];
    newState = (0, _assign2.default)({}, _oldState, stateChange);
    _state.state[container] = newState;
  }

  var topic = container === change ? _Constants2.default.updateState + "." + container.toUpperCase() : _Constants2.default.updateState + "." + container.toUpperCase() + "." + change.toUpperCase();

  // PubSub.publish(topic, { id, data, state: newState });
  return newState;
};

exports.setState = setState;
var clearState = function clearState(key) {
  var cart = _state.state.cart,
      states = (0, _objectWithoutProperties3.default)(_state.state, ["cart"]);

  var _ref3 = (0, _entries2.default)(states).find(function (_ref5) {
    var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
        name = _ref6[0],
        values = _ref6[1];

    return (0, _keys2.default)(values).includes(key);
  }) || [],
      _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
      group = _ref4[0];

  if (_state.state[key]) {
    _state.state[key] = {};
  } else if (group !== undefined) {
    delete _state.state[group][key];
  }

  return _state.state;
};
exports.clearState = clearState;